export const MAIN_NAV = [
  {
    "title": "Asuransi Mobil",
    "link": "#",
    "childItems": [
      {
        "title": "Asuransi Mobil Terbaik",
        "link": "/produk/asuransi-mobil/",
      },
      {
        "title": "Asuransi Mobil All Risk",
        "link": "/produk/asuransi-mobil/all-risk/",
      },
      {
        "title": "Asuransi Mobil TLO",
        "link": "/produk/asuransi-mobil/tlo/",
      },
      {
        "title": "Asuransi Mobil Syariah",
        "link": "/produk/asuransi-mobil/syariah/",
      },
      {
        "title": "Asuransi Mobil Bekas",
        "link": "/produk/asuransi-mobil/bekas/",
      },
      {
        "title": "Asuransi Mobil Pihak Ketiga",
        "link": "/produk/asuransi-mobil/pihak-ketiga/",
      },
      {
        "title": "Asuransi Mobil Listrik",
        "link": "/produk/asuransi-mobil/listrik/",
      }
    ]
  },
  {
    "title": "Asuransi Kesehatan",
    "link": "#",
    "childItems": [
      {
        "title": "Asuransi Kesehatan Terbaik",
        "link": "/produk/asuransi-kesehatan/",
      },
      {
        "title": "Asuransi Kesehatan Orangtua",
        "link": "/produk/asuransi-kesehatan/orangtua/",
      },
      {
        "title": "Asuransi Kesehatan Keluarga",
        "link": "/produk/asuransi-kesehatan/keluarga/",
      },
      {
        "title": "Asuransi Kesehatan Anak",
        "link": "/produk/asuransi-kesehatan/anak/",
      },
      {
        "title": "Asuransi Rawat Jalan",
        "link": "/produk/asuransi-kesehatan/rawat-jalan/",
      },
      {
        "title": "Asuransi Melahirkan",
        "link": "/produk/asuransi-kesehatan/melahirkan/",
      },
      {
        "title": "Asuransi Gigi",
        "link": "/produk/asuransi-kesehatan/gigi/",
      },
      {
        "title": "Hospital Cash Plan",
        "link": "/produk/asuransi-kesehatan/hospital-cash-plan/",
      },
      {
        "title": "Asuransi Karyawan",
        "link": "/produk/asuransi-karyawan/",
      }
    ],
  },
  {
    "title": "Rekan",
    "link": "#",
    "childItems": [
      {
        "title": "Asuransi Mobil Garda Oto",
        "link": "/produk/asuransi-mobil/garda-oto/",
      },
      {
        "title": "Asuransi Mobil Zurich Syariah",
        "link": "/produk/asuransi-mobil/zurich-autocillin/",
      },
      {
        "title": "Asuransi Mobil ACA",
        "link": "/produk/asuransi-mobil/aca/",
      },
      {
        "title": "Asuransi Mobil Roojai-Sompo",
        "link": "/produk/asuransi-mobil/sompo/",
      },
      {
        "title": "Asuransi Mobil Mega Insurance",
        "link": "/produk/asuransi-mobil/mega/",
      },
      {
        "title": "Asuransi Mobil Simas Insurtech",
        "link": "/produk/asuransi-mobil/simas-insurtech/",
      },
      {
        "title": "Asuransi Mobil Oona",
        "link": "/produk/asuransi-mobil/oona/",
      },
      {
        "title": "Asuransi Mobil MAG",
        "link": "/produk/asuransi-mobil/mag/",
      },
      {
        "title": "Asuransi Kesehatan Sinar Mas",
        "link": "/produk/asuransi-kesehatan/sinar-mas/",
      },
      {
        "title": "Asuransi Kesehatan AXA",
        "link": "/produk/asuransi-kesehatan/axa/",
      },
      {
        "title": "Asuransi Kesehatan Lippo General Insurance",
        "link": "/produk/asuransi-kesehatan/lippo/",
      },
      {
        "title": "Asuransi Kesehatan CAR Life",
        "link": "/produk/asuransi-kesehatan/car/",
      },
      {
        "title": "Asuransi Kesehatan MAG",
        "link": "/produk/asuransi-kesehatan/mag/",
      }
    ],
  },
  {
    "title": "Artikel & Tips",
    "link": "#",
    "childItems": [
      {
        "title": "Mengerti Asuransi",
        "link": "#",
        "childItems": [
          {
            "title": "Polis Asuransi",
            "link": "/media/asuransi/polis-asuransi/",
          },
          {
            "title": "Premi Asuransi",
            "link": "/media/asuransi/premi-asuransi/",
          },
          {
            "title": "Jenis Asuransi",
            "link": "/media/asuransi/jenis-asuransi/",
          },
          {
            "title": "Risiko Asuransi",
            "link": "/media/asuransi/risiko-asuransi/",
          },
          {
            "title": "Klaim Asuransi",
            "link": "/media/asuransi/klaim-asuransi/",
          }
        ],
      },
      {
        "title": "Artikel Lainnya",
        "link": "#",
        "childItems": [
          {
            "title": "Semua Artikel",
            "link": "/media/",
          },
          {
            "title": "Tips Asuransi",
            "link": "/media/asuransi/",
          },
          {
            "title": "Tips Asuransi Mobil",
            "link": "/media/asuransi-mobil/",
          },
          {
            "title": "Tips Asuransi Kesehatan",
            "link": "/media/asuransi-kesehatan/",
          },
          {
            "title": "Review Perusahaan Asuransi",
            "link": "/media/perusahaan-asuransi/",
          },
          {
            "title": "Tips Kendaraan & Asuransi",
            "link": "/media/tips-kendaraan-asuransi/",
          },
          {
            "title": "Tips Kesehatan & Asuransi",
            "link": "/media/tips-kesehatan-asuransi/",
          },
          {
            "title": "Kalkulator",
            "link": "/media/kalkulator/",
          }
        ],
      }
    ],
  },
  {
    "title": "Layanan",
    "link": "#",
    "position": "right",
    "dropdownPos": "right",
    "childItems": [
      {
        "title": "Tentang Lifepal",
        "link": "/tentang/",
      },
      {
        "title": "Bantuan",
        "link": "/pusat-bantuan/",
      },
      {
        "title": "Ketentuan",
        "link": "/ketentuan/",
      },
      {
        "title": "Cara Pembelian",
        "link": "/cara-beli/",
      }
    ],
  }
];